import React from 'react';
import { Sidebox as SideBox, Button } from '@platform/base';
import { getSysFieldid } from '@platform/api';
import Form from '@platform/form';

// TODO 侧拉编辑里的编辑前后事件
function useEditTable(Table){
    return class SideEditTable extends React.Component{
        render(){
            const { open } = this.props.modalConfig || {};
            return (
                <>
                    <Table {...this.props} />
                    {open && <SideEdit {...this.props}/>}
                </>
            );
        }
    };
}

useEditTable.displayName = 'useEditTable';
useEditTable.dependence = [];
useEditTable.hooks = function(){
    this.store.sideEditInfo = {};
    this._formatOutputRow = row => {
        if (!row) return;
        return { 
            rowid: row.key, 
            rowId: row.key, 
            status: row.status, 
            selected: this.getCheckedKeys().has(row.key),
            values: row.values,
        };
    };

    return {
        openSideEdit: (status, dataIndex) => {
            let rows = this.getRows();
            
            if (status == 'add') {
                dataIndex = rows.length;
                this.addRow(dataIndex, [{}], { autoFocus: false });
            }

            this.store.sideEditInfo = {
                open: true,
                status,
                dataIndex,
                cachedRows: JSON.parse(JSON.stringify(rows)),
                meta: this.store.leafColumnKeys
                    .filter(key => {
                        let { itemtype: itemType } = this.getColumnProps(key);
                        return itemType !== 'label' && itemType !== 'customer';
                    })
                    .map(key => this.getColumnProps(key)),
            };
            this.forceUpdate();
        },
        closeSideEdit: () => {
            this.store.sideEditInfo = {
                ...this.store.sideEditInfo,
                open: false,
            };
            this.forceUpdate();
        },
        getSideEditInfo: () => {
            return this.store.sideEditInfo;
        },
        setEditFormStore: store => {
            this.editFormStore = store;
        },
        getEditFormStore: () => {
            return this.editFormStore;
        },
    };
};
useEditTable.propsGenerator = function(props) {
    const { modalConfig, store } = props,
        { status, dataIndex, cachedRows } = store.getSideEditInfo(),
        record = store.getRows()[dataIndex];

    return {
        ...props,
        modalConfig: {
            ...modalConfig,
            ...store.getSideEditInfo(),
            onClose: () => {
                if (status === 'add') {
                    store.deleteRow(record.key);
                } else if (status === 'edit') {
                    store.setRowData(cachedRows);
                }

                // 关闭弹窗
                store.closeSideEdit();
                modalConfig?.onClose?.(record);
            },
            onSure: () => {
                store.closeSideEdit();
                modalConfig?.onSure?.(record);
            },
            onAdd: () => {
                let rows = store.filterEmptyRows();
                store.setRows({ rows });
                store.openSideEdit('add');
                modalConfig?.onAdd?.(record);
            },
        },
    };
};

class SideEdit extends React.Component {
    formStore = Form.useForm();

    componentDidMount() {
        let { store } = this.props;
        let { meta, dataIndex, status } = this.props.modalConfig || {},
            record = store.getRows()[dataIndex];

        this.formStore.setMeta({
            sideEdit: {
                status: status === 'edit' || status === 'add' ? 'edit' : 'browse',
                items: meta.filter(column => {
                    if(column.render && column.itemtype !== 'customer') {
                        column.renderStatus = column.renderStatus || 'edit';
                    }
                    return column.itemtype !== 'customer';
                }),
                moduletype: 'form',
                name: `${/*locale['side_edit']*/'侧拉编辑'}`,
                isunfold: false,
            },
        });
        this.formStore.setAllFormValue(record?.values || {});

        store.setEditFormStore(this.formStore);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { modalConfig, store } = nextProps,
            { status, dataIndex } = modalConfig,
            record = store.getRows()[dataIndex];

        this.formStore.setStatus(status === 'edit' || status === 'add' ? 'edit' : 'browse');
        this.formStore.setAllFormValue(record?.values || {});
    }

    handleFormBeforeEvent = (moudleId, attrcode, value, values, column, event) => {
        let { store, onBeforeEvent } = this.props,
            { dataIndex } = store.getSideEditInfo(),
            rowKey = store.getRows()[dataIndex].key;

        return onBeforeEvent?.({ value, event, colKey: attrcode, rowKey });
    }

    handleFormAfterEvent = ({
        attrcode,
        value, 
        oldValue, 
        componentValue,
        event,
    }) => {
        let { store, onAfterEvent } = this.props,
            { dataIndex } = store.getSideEditInfo(),
            rowKey = store.getRows()[dataIndex].key;

        onAfterEvent?.({ value, oldValue, componentValue, event, colKey: attrcode, rowKey });
    }

    render(){
        let { modalConfig = {}, locale = {}, fieldid, id } = this.props;
        let { open, onClose, onSure, onAdd, status } = modalConfig;
        let title = locale['table0015'] || '标题';
        switch (status) {
            case 'add':
                title = locale['table0016'] || '新增';
                break;
            case 'edit':
                title = locale['table0017'] || '编辑';
                break;
            default:
                break;
        }
        return <SideBox
            show={open}
            mask={true}
            title={title}
            onClose={onClose}
        >
            <div className='sidebox-edit' fieldid={getSysFieldid(`${fieldid || id}_modal-area`)}>
                <div className='sidebox-edit-body' fieldid={getSysFieldid(`${id}_form-area`)}>
                    <Form
                        name='sideEdit'
                        config={{
                            onAfterEvent: this.handleFormAfterEvent,
                            onBeforeEvent: this.handleFormBeforeEvent,
                        }}
                        store={this.formStore}
                    />
                </div>
                <div className='sidebox-edit-footer' fieldid={getSysFieldid('bottom-area')}>
                    <Button
                        onClick={onClose}
                    >
                        {locale['table_cancel'] || '取消'}
                    </Button>
                    <Button
                        colors="primary"
                        onClick={onSure}
                    >
                        {locale['table_ok'] || '确定'}
                    </Button>
                    {status === 'add' && <Button
                        onClick={onAdd}
                    >
                        {locale['new_add_and_save'] || '新增保存'}
                    </Button>}
                </div>
            </div>
        </SideBox>;
    }

    componentWillUnmount() {
        let { store } = this.props;

        store.setEditFormStore(null);
    }
}

export default useEditTable;